import { ISoftDelete } from '@principle-theorem/shared';

export enum TwainColourMode {
  Monochrome = 'monochrome',
  Grayscale = 'grayscale',
  Colour = 'colour',
  DeviceDefault = 'default',
}

export enum TwainSaveColourMode {
  Monochrome = 0,
  Grayscale = 1,
  Colour = 2,
  DeviceDefault = 3,
}

export const TWAIN_COLOUR_TO_TWAINSAVE_COLOUR_MAP: Record<
  TwainColourMode,
  TwainSaveColourMode
> = {
  [TwainColourMode.Monochrome]: TwainSaveColourMode.Monochrome,
  [TwainColourMode.Grayscale]: TwainSaveColourMode.Grayscale,
  [TwainColourMode.Colour]: TwainSaveColourMode.Colour,
  [TwainColourMode.DeviceDefault]: TwainSaveColourMode.DeviceDefault,
};

export enum TwainSaveTransferMode {
  Native = 0,
  Buffered = 1,
}

export enum TwainTransferMode {
  Native = 'native',
  Buffered = 'buffered',
}

export enum TwainImplementation {
  TwainSave = 'twainsave',
  TwainCli = 'twain-cli',
  NAPS2 = 'naps2',
}

export enum TwainCliScanMode {
  Single = 'single',
  Multi = 'multi',
}

export enum TwainCliCommand {
  Scan = 'scan',
  ListDevices = '--listDevices',
}

export enum TwainCliOption {
  Device = '--device',
  Output = '--output',
  Colour = '--colour',
  Transfer = '--transfer',
  Verbose = '--verbose',
}

export interface ITwainCliDevice {
  name: string;
}

export interface ITwainCliScanResult {
  success: boolean;
  errorMessage?: string;
}

export const TWAIN_TRANSFER_MODE_MAP: Record<
  TwainTransferMode,
  TwainSaveTransferMode
> = {
  [TwainTransferMode.Native]: TwainSaveTransferMode.Native,
  [TwainTransferMode.Buffered]: TwainSaveTransferMode.Buffered,
};

export interface ITwainDevice extends ISoftDelete {
  name: string;
  uid: string;
  /** @deprecated Use `implementation: TwainImplementation.NAPS2` instead */
  compatibilityMode?: boolean;
  colourMode?: TwainColourMode;
  transferMode?: TwainTransferMode;
  multiImageEnabled?: boolean;
  implementation?: TwainImplementation;
  verboseLogging?: boolean;
}

export interface IBridgeTwainSettings {
  devices: ITwainDevice[];
  syncing: boolean;
}
